import { Component, OnDestroy, OnInit, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterEvent,
} from '@angular/router';
import { Subscription } from 'rxjs';
import { CasesService } from 'src/app/core/services/cases.service';
import { UnitsService } from 'src/app/core/services/units.service';
import { UserService } from 'src/app/core/services/user.service';
import { ICaseType } from 'src/app/modules/unit/interfaces/case-type.interface';
import { IUnit } from 'src/app/modules/unit/interfaces/unit.interface';

@Component({
  selector: 'header-without-assigned',
  templateUrl: './header-without-assigned.component.html',
  styleUrls: ['./header-without-assigned.component.scss'],
})
export class HeaderWithoutAssignedComponent implements OnInit {
  @Input() view;
  routerSuscription: Subscription;
  unitId!: string;
  caseTypes: ICaseType[] = [];
  filters = {};
  constructor(
    private readonly userService: UserService,
    private readonly router: Router,
    private route: ActivatedRoute,
    private readonly unitsService: UnitsService,
    private readonly dialog: MatDialog,
    private readonly casesService: CasesService
  ) {
    this.unitId = this.route.snapshot.paramMap.get('id');
    this.getUnit();
    this.getCaseTypes();
    this.routerSuscription = this.router.events.subscribe(
      async (event: RouterEvent) => {
        if (event instanceof NavigationEnd) {
          this.unitId = route.snapshot.paramMap.get('id');
          this.getUnit();
          this.getCaseTypes();
        }
      }
    );
  }

  ngOnDestroy(): void {
    this.routerSuscription?.unsubscribe();
  }
  ngOnInit() {
    this.casesService.filterDataRas.subscribe({
      next: (filters: any) => {
        if (filters.assigned == '') {
          delete filters.assigned;
        }
        this.filterData(filters);
      },
    });
  }
  search = '';
  unit!: IUnit;
  searchTouch: boolean;
  users;

  loading = false;
  async getUnit() {
    this.loading = true;
    await this.unitsService.getById(this.unitId).subscribe({
      next: (unit) => {
        this.loading = false;
        this.unit = unit;
      },
    });
  }
  async findUser() {
    await this.userService.getUsersByRole(this.caseTypes[0].role).subscribe({
      next: (users) => {
        this.users = users;
      },
    });
  }

  get canCreate() {
    let permission = this.userService.permissions?.createCases;
    /* En caso de ser incidencia no mostrar crear */
    let isIncidencia = this.unit?.name == 'Incidencias' ? true : false;
    return permission && !isIncidencia;
  }
  get seeArchived() {
    let permission = this.userService.permissions?.seeArchivedCases;
    /* En caso de ser incidencia no mostrar casos archivados */
    let isIncidencia = this.unit?.name == 'Incidencias' ? true : false;
    return permission && !isIncidencia;
  }

  getCaseTypes() {
    this.unitsService.getTypeCases(this.unitId).subscribe({
      next: (caseTypes) => {
        this.caseTypes = caseTypes;
        this.findUser();
        caseTypes.forEach((caseType) => {
          this.filters[caseType._id] = false;
        });
      },
    });
  }
  filterData(filters = {}) {
    let filter = {
      caseType: this.caseTypes[0]._id,
      search: this.search,
    };
    if (this.search) {
      filters['search'] = this.search;
      filters['caseType'] = this.caseTypes[0]._id;
    }
    this.casesService.filterDataRasSearch.next(filters);
  }
}
